export const getLowerCaseColumnTitles = (
  columnTitles?: string[]
): Record<string, string> => {
  if (!columnTitles || !columnTitles.length) {
    return {}
  }

  const output: Record<string, string> = {}
  for (const column of columnTitles) {
    output[column.toLowerCase()] = column
  }

  return output
}
